import { cva } from '@/styled-system/css';

export const connectedCardRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: { base: 'tight', lg: '{spacing.loose} {spacing.looser} {spacing.looser} {spacing.looser}' },
    backgroundColor: 'bg.neutral',
    border: '1px solid {colors.border.muted}',
    borderRadius: 'obj.default',
    /* helps vertically center the spinner */
    '& .SpinnerContainer': {
      flexGrow: 2,
    },
  },
  variants: {
    includeBorderTop: {
      true: {
        borderTop: '3px solid {colors.border.accent.brand.hero}',
      },
    },
    enableHover: {
      true: {
        backgroundColor: 'bg.accent.blue.soft',
        borderColor: 'border.accent.blue.hero',
      },
    },
    hideBorderOnMobile: {
      true: {
        border: { base: 'none', md: '1px solid {colors.border.muted}' },
      },
    },
  },
});

export const headingWrapperRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: { base: '400', lg: '600' },
    justifyContent: { lg: 'space-between' },
  },
  variants: {
    justifyHeadingContent: {
      'flex-start': {
        justifyContent: { base: 'flex-start', lg: 'space-between' },
      },
      center: {
        justifyContent: { base: 'center', lg: 'space-between' },
      },
      'space-between': {
        justifyContent: 'space-between',
      },
    },
  },
});
